import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"

import { fetchTags } from "./api"

export function useFetchTags(entityType?: string, options?: { enabled?: boolean; bookIdOverride?: string }) {
  const urlBookId = useBookId()
  const bookId = options?.bookIdOverride ?? urlBookId
  const getContext = useApiContext(options?.bookIdOverride)

  return useQuery({
    queryKey: ["tags", entityType, bookId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchTags(context, entityType)
    },
    enabled: options?.enabled ?? true,
    retry: false,
  })
}
